export const CHECKOUT = 'CHECKOUT'

export const PAYMENTS_PLANS = 'PAYMENTS_PLANS'
export const SELECTED_PLAN = 'SELECTED_PLAN'
export const CURRENTPLAN = 'CURRENTPLAN'
export const GET_FREE_PLAN = 'GET_FREE_PLAN'
export const CANCELSUBSCRIPTION = 'CANCELSUBSCRIPTION'
export const FINANCIAL_STATMENT_TRANSLATION_PLANS = 'FINANCIAL_STATMENT_TRANSLATION_PLANS'

export const PAY_BY_PAYPAL = 'PAY_BY_PAYPAL'
export const PAYPAL_SUCCESS = 'PAYPAL_SUCCESS'

export const GET_EXCHANGE_RATE = 'GET_EXCHANGE_RATE'

export const GET_SAVE_CARDS = 'GET_SAVE_CARDS'
export const SAVE_NEW_CARD = 'SAVE_NEW_CARD'
export const DELETE_CARD = 'DELETE_CARD'



// WEBPACK FOOTER //
// ./src/actions/payments.js